import { fetcher } from '@commenda/utils';

export type TUpdateMailroomMappingParams = {
  corporationId: number;
  sourceId: string;
};

export async function createMailroomMapping(
  params: TUpdateMailroomMappingParams
): Promise<{ success: boolean; message: string }> {
  const res = await fetcher(
    `mailroom/admin/corporation/${params.corporationId}/dra-company-mapping`,
    {
      method: 'POST',
      body: { sourceId: params.sourceId },
    }
  );

  if (!res.ok) {
    return {
      success: false,
      message: 'Failed to create mailroom mapping.',
    };
  }

  return {
    success: true,
    message: 'Mailroom mapping created successfully.',
  };
}
